import type { MaterialInfo, PartDefinition } from '@rogue/rackbuilder'
import type { RackOptions } from '../../../RackTypes'
import { getRackModel } from '../../../modelPaths'
import { MaterialBuilder } from './materialBuilder'

/**
 * Handles middle spanning crossmember
 * - Multi-grip pullup bar
 * - Fat/skinny pullup bar
 * 
 * Attaches to the top structural crossmember between front uprights
 */
export class MiddleCrossmemberBuilder {
  private isAddon: boolean

  constructor(
    private config: RackOptions,
    private materialBuilder: MaterialBuilder
  ) {
    this.isAddon = !!this.config.isAddon
  }
  
  /**
   * Creates middle spanning connection (multi-grip or fat/skinny)
   * Returns undefined if no middle option configured
   */
  createMiddleCrossmember(): PartDefinition | undefined {
    if (!this.config.middle) return undefined
    
    const materials = this.isAddon ? this.createAddonMaterials() : this.materialBuilder.createMiddleOptionMaterials()
    
    if (this.config.middle === 'multi grip') {
      return this.createMultiGrip(materials)
    }
    
    return this.createFatSkinnyBar(materials)
  }

  private createAddonMaterials() {
    return this.materialBuilder.createAddonMaterials()
  }
  
  private createMultiGrip(materials: MaterialInfo): PartDefinition {
    return {
      mesh   : getRackModel('SPECIALTY_PARTS', 'multi grip'),
      anchor : 'left',
      slots  : {},
      offset : { y: 0, x: -0.5, z: -6 },
      materials,
    }
  }
  
  private createFatSkinnyBar(materials: MaterialInfo): PartDefinition {
    const offset = this.config.depth === '3' 
      ? { y: 0, x: 0, z: -6 } 
      : { y: 0, x: 0, z: -4 }
    
    return {
      mesh        : getRackModel(`${this.config.line}_PULLUP`, 'fat skinny'),
      anchor      : 'left',
      slots       : {},
      adjustments : [{ type: 'rotate', axis: 'X', amount: 90 }],
      offset,
      materials,
    }
  }
}